import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { track } from "../../lib/analytics";

const NAV = [
  { id: "travel", label: "Travel" },
  { id: "yoga", label: "Yoga Retreats" },
  { id: "wellness", label: "Wellness & Party" },
  { id: "adventure", label: "Adventure" },
];

export const Header = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const go = (id) => {
    setOpen(false);
    track("nav_link_clicked", { link: id });
    onNavigate?.(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`glass-nav fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "py-2" : "py-3 md:py-4"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 md:px-10">
        <button
          data-testid="brand-logo"
          onClick={() => { track("nav_link_clicked", { link: "logo" }); onNavigate?.("top"); }}
          className="flex items-center gap-2 text-left"
        >
          <span className="inline-block h-2 w-2 rounded-full bg-brand-terracotta" />
          <span className="font-display text-lg md:text-xl tracking-tight text-brand-ink">
            Yoga<span className="italic text-brand-terracotta">to</span>Yacht
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="link-underline text-sm font-medium tracking-wide text-brand-ink/85 hover:text-brand-ink"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-explore"
            onClick={() => go("all")}
            className="hidden md:inline-flex items-center rounded-full bg-brand-ink px-5 py-2.5 text-sm font-medium text-white transition-colors duration-300 hover:bg-brand-inkSoft"
          >
            Explore escapes
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-line"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden mx-6 mt-3 rounded-2xl border border-brand-line bg-white/95 p-5 shadow-xl shadow-black/5 backdrop-blur"
        >
          <div className="flex flex-col gap-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left text-base font-medium text-brand-ink"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-cta"
              onClick={() => go("all")}
              className="mt-2 rounded-full bg-brand-ink px-5 py-3 text-sm font-medium text-white"
            >
              Explore all escapes
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
